module.exports = (__webpack_require__(2))(85);


//////////////////
// WEBPACK FOOTER
// delegated ./src/utilities/jquery/girderModal.js from dll-reference girder_plugin_slicer_cli_web
// module id = 23
// module chunks = 0